import { BehaviorParameters } from 'rangeConfig/@types';
import { getUprights } from '@inter-ikea-storagetwo/boaxel/dist/utils/sectionsHelpers';
import MountingRailComponent from '@inter-ikea-storagetwo/boaxel/dist/components/MountingRailComponent';
import { ComponentIds } from '@inter-ikea-core/core';
import { ErrorMessages } from '@inter-ikea-storageone/range';

//TODO: Make clothes rail possible to add to inserts
const addInteriorToSection = ({ coreApi, props }: BehaviorParameters) => {
  const coreProductId = props.coreProductId || props.coreProductIds[0];
  const selectedEntity = coreApi.entities
    .getByComponent(ComponentIds.SELECTED_COMPONENT_ID)
    .find(e => e.hasComponent(MountingRailComponent.id));

  if (!selectedEntity) return;

  const { leftUpright } = getUprights(selectedEntity);

  if (!leftUpright) return;

  const placementResult = coreApi.products.addToTarget(coreProductId, leftUpright);

  if (!placementResult.valid && placementResult.errors && placementResult.errors.length > 0) {
    coreApi.emit.onPlacementAttempt(ErrorMessages.ItemWontFit);

    coreApi.entities.disposeCollidingEntities(placementResult.errors);
  }
};

export default addInteriorToSection;
